module.exports = __webpack_public_path__ + "static/media/WorldGym.9b499d13.png";